export function updateSearchResultHtml(container: Element, html: string, loadMore: boolean): void {
	if (!loadMore) {
		container.innerHTML = html;
		return;
	}

	container.insertAdjacentHTML('beforeend', html);
}
